import { useState } from 'react';

import { Btn } from '../../components/Btn';

export function useStockCursor(key: string) {
  const [state, setState] = useState({ key, cursors: [] as string[] });
  const cursors = state.key === key ? state.cursors : [];
  return {
    cursor: cursors.at(-1),
    page: cursors.length + 1,
    previous: () => setState({ key, cursors: cursors.slice(0, -1) }),
    next: (cursor: string) => setState({ key, cursors: [...cursors, cursor] }),
  };
}

export function StockPagination({
  pager,
  hasMore,
  nextCursor,
  pending,
}: {
  pager: ReturnType<typeof useStockCursor>;
  hasMore?: boolean;
  nextCursor?: string;
  pending: boolean;
}) {
  return (
    <div className="mt-4 flex items-center justify-between gap-3">
      <Btn disabled={pager.page === 1 || pending} onClick={pager.previous}>
        ก่อนหน้า
      </Btn>
      <span>หน้า {pager.page}</span>
      <Btn
        disabled={!hasMore || !nextCursor || pending}
        onClick={() => {
          if (nextCursor) pager.next(nextCursor);
        }}
      >
        ถัดไป
      </Btn>
    </div>
  );
}
